<h3 class="card-header">{{ "RESET_PASSWORD" | translate }}</h3>
<div class="card-body">
  <div *ngIf="tokenStatus == TokenStatus.Validating">Validating token...</div>
  <div *ngIf="tokenStatus == TokenStatus.Invalid">
    Token validation failed, if the token has expired you can get a new one at
    the <a routerLink="/account/forgot-password">forgot password</a> page.
  </div>
  <form
    *ngIf="tokenStatus == TokenStatus.Valid"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <div class="form-group">
      <label>{{ "REGISTER_PASSWORD" | translate }}</label>
      <input
        type="password"
        formControlName="password"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
      />
      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
        <div *ngIf="f.password.errors.required">
          {{ "REGISTER_MSG_REQUIRED_PASSWORD" | translate }}
        </div>
        <div *ngIf="f.password.errors.minlength">
          {{ "REGISTER_MSG_PASSWORD_8" | translate }}
        </div>
        <div *ngIf="f.password.errors.passwordComplexity">
          {{ "REGISTER_MSG_PASSWORD_COMPLEXITY" | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>{{ "REGISTER_CONFIRM_PASSWORD" | translate }}</label>
      <input
        type="password"
        formControlName="confirmPassword"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
      />
      <div
        *ngIf="submitted && f.confirmPassword.errors"
        class="invalid-feedback"
      >
        <div *ngIf="f.confirmPassword.errors.required">
          {{ "REGISTER_MSG_CONFIRM_PASSWORD" | translate }}
        </div>
        <div *ngIf="f.confirmPassword.errors.mustMatch">
          {{ "REGISTER_MSG_PASSWORD_NOT_MATCH" | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <button [disabled]="loading" class="btn btn-primary">
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ "RESET_PASSWORD" | translate }}
      </button>
      <a routerLink="../login" class="btn btn-link">{{
        "REGISTER_CANCEL" | translate
      }}</a>
    </div>
  </form>
</div>
